{
  "Clear search": "Очистити пошук"
}